import { SessionProps } from '@bimone/bimtrack-core';
import { createTransform } from 'redux-persist';
import { SessionPersistDto } from './types';
import { serializeUser, deserializeUser } from './serialization/userSerialization';
import { serializeHub, deserializeHub } from './serialization/hubSerialization';
import { serializeProject, deserializeProject } from './serialization/projectSerialization';

export const sessionTransform = createTransform(
  // Transform state on its way to being serialized and persisted.
  (inboundState: SessionProps): SessionPersistDto => {
    return {
      user: serializeUser(inboundState.user),
      hub: serializeHub(inboundState?.hub),
      project: serializeProject(inboundState?.project),
      bimTrackApiUrl: inboundState.bimTrackApiUrl,
    };
  },
  // Transform state being rehydrated
  (outboundState: SessionPersistDto): SessionProps => {
    return {
      user: deserializeUser(outboundState.user),
      hub: deserializeHub(outboundState.hub),
      project: deserializeProject(outboundState.project),
      bimTrackApiUrl: outboundState.bimTrackApiUrl,
    };
  },
  { whitelist: ['session'] }
);
